/* ct-notify.js — "Notify me when it's back" on a sold-out size (Carbontree, 14 Oct 2026).
 *
 * The sold-out size's own Add-to-cart button becomes "Notify me when it's back"
 * (not a new button under it), and the WhatsApp-number box is already open
 * where Buy now was — no tap to open it. A number we already know (KwikPass
 * login, or an earlier sign-up on this phone) is filled in, so one tap on
 * Notify me is the whole thing. Saves to mail.carbontree.com/n.
 * Sizes on "Continue selling" show as buyable and never get this.
 *
 * Hooks the theme's own size change (variant-options: toggleAddButton,
 * updateATCText, the variantChangeEnd event) so the theme can't flip the
 * button back to "Sold out". Also guards one theme crash on a sold-out
 * size's link (safeInventory below). Undo = remove this file's script tag from
 * layout/theme.liquid.
 *
 * Set pages (YourToken's picker greys out sold-out piece sizes and they can't be
 * tapped): a box under the set's own Add to Cart lists each piece's sold-out sizes;
 * the shopper picks theirs and leaves a number. Never touches YourToken's picker,
 * prices or cart. Only on pages named Set / Co-ord — packs share the picker.
 */
(function () {
  if (window.ctNotify) return
  window.ctNotify = true

  var ENDPOINT = 'https://mail.carbontree.com/n'
  var KEY_CONTACT = 'ct_notify_contact'   // {p:"98…"} or {e:"a@b.c"} — the shopper's own, on their own phone
  var KEY_DONE = 'ct_notify_done'         // variant ids already asked for
  var TXT = { cta: 'Notify me when it’s back', pick: 'Select size to get notified', sticky: 'Notify me', stickyDone: '✓ We’ll tell you', go: 'Notify me' }

  // this page's own copy first: a phone that blocks storage still sees its ✓ and never sends twice
  var mem = {}
  function get(k) { if (k in mem) return mem[k]; try { return JSON.parse(localStorage.getItem(k) || 'null') } catch (e) { return null } }
  function put(k, v) { mem[k] = v; try { localStorage.setItem(k, JSON.stringify(v)) } catch (e) {} }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;') }
  function mobile(s) { var m = String(s || '').replace(/\D/g, '').match(/^(?:0|91|091)?([6-9]\d{9})$/); return m ? m[1] : null }
  function email(s) { s = String(s || '').trim().toLowerCase(); return /^[^\s@,;<>]+@[^\s@,;<>]+\.[a-z]{2,}$/i.test(s) ? s : null }
  function cookie(n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : null }
  // a number the phone already gave the store: our own earlier sign-up, else KwikPass's login
  function knownContact() {
    var c = get(KEY_CONTACT)
    if (c && (mobile(c.p) || email(c.e))) return c.p ? { p: mobile(c.p) } : { e: email(c.e) }
    var kp = null
    try { kp = localStorage.getItem('notify_phone_number') } catch (e) {}
    kp = mobile(kp || cookie('notify_phone_number'))
    return kp ? { p: kp } : null
  }
  // the shopper's KwikPass login on this phone, sent with a sign-up: the email they gave it and their store
  // account's id. Only while they're logged in (KwikPass marks it ENABLED).
  function kpLogin() {
    function ls(k) { try { return String(localStorage.getItem(k) || '').replace(/^"|"$/g, '').trim() } catch (e) { return '' } }
    if (ls('kp_customer_state') !== 'ENABLED') return null
    var e = email(ls('kp_email')), id = (ls('kp_customer_id').match(/(\d{6,20})$/) || [])[1] || null
    return e || id ? { e: e || '', id: id || '' } : null
  }
  // sizes this phone asked for, forgotten after 15 days — so once someone is told and the
  // size sells out again, they can ask again. A repeat while their ask is still open is
  // ignored when it arrives, so a person is never counted twice for one size.
  var DONE_DAYS = 15
  function doneList() {
    var d = get(KEY_DONE), cut = Date.now() - DONE_DAYS * 864e5
    return (Array.isArray(d) ? d : []).map(function (x) { return typeof x === 'string' ? { id: x, at: 0 } : x })   // an undated old entry has expired
      .filter(function (x) { return x && x.id && x.at > cut })
  }
  function isDone(id) { return doneList().some(function (x) { return x.id === String(id) }) }
  function markDone(id) { var d = doneList().filter(function (x) { return x.id !== String(id) }); d.unshift({ id: String(id), at: Date.now() }); put(KEY_DONE, d.slice(0, 50)) }
  function unmarkDone(id) { put(KEY_DONE, doneList().filter(function (x) { return x.id !== String(id) })) }
  function said(c) { return c.p ? 'WhatsApp you' : 'email you' }
  function masked(c) { return c.p ? '••••••' + c.p.slice(-4) : c.e.replace(/^(.{2}).*(@.*)$/, '$1•••$2') }

  // How this visit reached the website, sent with a sign-up: the first page's query (ad platforms' click ids
  // blanked: only that one was there, never its value), the referring site's name and the page. Kept for the
  // tab's visit, since the shopper usually signs up a few pages later. This script runs on product pages
  // only, so a visit that began elsewhere on the store is read from Shopify's own note of its first page.
  var KEY_LAND = 'ct_notify_land'
  function hostOf(u) { try { return new URL(u).hostname.toLowerCase() } catch (e) { return '' } }
  function ours(h) { return h === location.hostname || /(^|\.)carbontree\.com$|\.myshopify\.com$|\.shopifypreview\.com$/.test(h) }
  function landFrom(url, ref) {
    var u
    try { u = new URL(url, location.href) } catch (e) { return null }
    var q = u.search.replace(/([?&](?:fbclid|gclid|gbraid|wbraid|oppref|msclkid|ttclid)=)[^&#]*/gi, function (m, k) { return k + '1' })
    if (q.length > 600) q = q.slice(0, Math.max(q.lastIndexOf('&', 600), 0))
    var r = hostOf(ref)
    return { q: q, r: r && !ours(r) ? r : '', l: u.pathname.slice(0, 150) }
  }
  function landing() {
    var r = hostOf(document.referrer), got = null
    // a tagged link (an ad, a send) is always a new arrival; otherwise the visit's first page stands
    if (/[?&](?:utm_|fbclid|gclid|gbraid|wbraid|oppref)/i.test(location.search)) got = landFrom(location.href, document.referrer)
    else {
      try { got = JSON.parse(sessionStorage.getItem(KEY_LAND) || 'null') } catch (e) {}
      if (got) return got
      if (!r || !ours(r)) got = landFrom(location.href, document.referrer)    // another site, or typed in / an app's link
      else {
        // they came from another page of the store: the visit's first page as Shopify noted it, if it looks
        // like an arrival (its referrer isn't the store itself)
        var first = null
        try { first = (JSON.parse(sessionStorage.getItem('__shopify_agent_context_events') || '[]') || []).filter(function (e) { return e && e.type === 'page_viewed' && e.url })[0] } catch (e) {}
        var fr = first ? hostOf(first.referrer || '') : ''
        if (first && ours(hostOf(first.url)) && !(fr && ours(fr))) got = landFrom(first.url, first.referrer || '')
      }
    }
    if (got) { try { sessionStorage.setItem(KEY_LAND, JSON.stringify(got)) } catch (e) {} }
    return got
  }
  // a sign-up never waits on these, and never grows past what the server takes
  function withExtras(body) {
    var k = null, l = null
    try { k = kpLogin() } catch (e) {}
    if (k && JSON.stringify(body).length + JSON.stringify(k).length < 1900) body.kp = k
    try { l = landing() } catch (e) {}
    if (l && JSON.stringify(body).length + JSON.stringify(l).length < 1900) body.src = l
    return body
  }

  var sentSteps = {}
  function step(ev) {
    if (sentSteps[ev]) return              // once per page view each, so every share is of shoppers
    sentSteps[ev] = true
    try { navigator.sendBeacon(ENDPOINT, new Blob([JSON.stringify({ ev: ev })], { type: 'text/plain' })) } catch (e) {}
  }

  function css() {
    if (document.getElementById('ct-notify-css')) return
    var s = document.createElement('style')
    s.id = 'ct-notify-css'
    s.textContent =
      'body.ct-notify-on main .shiprocket-headless,body.ct-notify-on main .shopify-payment-button{display:none!important}' +
      // full width of the buy area whatever its layout; the theme's big .button styles stay off our small one
      '.ct-notify-box{margin:10px 0 4px;font-family:inherit;width:100%;flex:1 1 100%;align-self:stretch;box-sizing:border-box}' +
      '.ct-notify-box .ct-nf{display:block!important;width:100%!important;max-width:none!important;margin:0!important}' +
      '.ct-nf-row{display:flex;align-items:stretch;width:100%;box-sizing:border-box;border:1px solid #2A3B33;border-radius:4px;overflow:hidden;background:#fff}' +
      '.ct-nf-cc{display:flex;align-items:center;padding:0 10px;font-size:16px;color:#55554F;border-right:1px solid #E7E6E1}' +
      '.ct-nf-in{flex:1;min-width:0;border:0;outline:0;padding:0 12px;height:48px;font-size:16px;color:#1A1B19;background:#fff;font-family:inherit}' +
      '.ct-notify-box .ct-nf-go{flex:0 0 auto!important;border:0!important;border-radius:0!important;margin:0!important;padding:0 18px!important;min-width:0!important;width:auto!important;height:auto!important;min-height:48px!important;font-size:13px!important;letter-spacing:.08em!important;cursor:pointer}' +
      '.ct-nf-hp{position:absolute;left:-9999px;width:1px;height:1px;opacity:0}' +
      '.ct-nf-done{display:flex;align-items:center;justify-content:center;min-height:48px;padding:8px 14px;box-sizing:border-box;border:1px solid #2A3B33;border-radius:4px;background:#EEF1EE;color:#2A3B33;font-size:15px;font-weight:600;text-align:center}' +
      '.ct-nf-note{font-size:12px;color:#55554F;margin-top:6px;line-height:1.5}' +
      '.ct-nf-note a{color:#1A1B19;text-decoration:underline;cursor:pointer}' +
      '.ct-nf-err{font-size:12px;color:#A8492A;margin-top:4px;min-height:0}' +
      // even padding all round; the colours in an even grid (2 across on a phone, 3+ wider) so no ragged gap on the right
      '.ct-alts{margin:14px 0 4px;width:100%;flex:1 1 100%;padding:14px;border:1px solid #2A3B33;border-radius:4px;box-sizing:border-box;background:#fff}' +
      '.ct-alts-h{font-size:14px;font-weight:700;color:#1A1B19;margin:0 0 12px;line-height:1.3}' +
      '.ct-alts-row{display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:8px}' +
      '.ct-alts .ct-alt{display:flex;align-items:center;gap:8px;min-width:0;padding:8px 10px;border:1px solid #E7E6E1;border-radius:8px;font-size:13px;line-height:1.25;color:#1A1B19;text-decoration:none!important;background:#fff;box-sizing:border-box}' +
      '.ct-alts .ct-alt-more{grid-column:1/-1;padding:8px 12px!important;border:1px dashed #C4C2BA!important;border-radius:8px!important;font-size:13px!important;color:#55554F!important;background:#fff!important;cursor:pointer;font-family:inherit;text-transform:none!important;letter-spacing:normal!important;min-height:0!important;width:100%!important;margin:0!important}' +
      '.ct-alts .ct-alt[hidden]{display:none}' +
      '.ct-alt:hover{border-color:#2A3B33}' +
      '.ct-set-box{padding:14px;border:1px solid #2A3B33;border-radius:4px;background:#fff;margin:14px 0 4px;width:100%;box-sizing:border-box;flex:1 1 100%;align-self:stretch}' +
      '.ct-set-piece{margin:0 0 12px}' +
      '.ct-set-name{font-size:13px;color:#55554F;margin:0 0 6px}' +
      '.ct-set-sizes{display:flex;flex-wrap:wrap;gap:6px}' +
      '.ct-set-box .ct-sz{min-width:48px;padding:8px 10px!important;border:1px solid #E7E6E1!important;border-radius:4px!important;background:#fff!important;color:#1A1B19!important;font-size:13px!important;font-family:inherit;letter-spacing:normal!important;text-transform:none!important;cursor:pointer;margin:0!important;height:auto!important;min-height:0!important;width:auto!important}' +
      '.ct-set-box .ct-sz.ct-sz-out{border-style:dashed!important;border-color:#B9B6AC!important}' +
      '.ct-set-box .ct-sz.ct-sz-on{background:#2A3B33!important;border-color:#2A3B33!important;border-style:solid!important;color:#fff!important}' +
      '.ct-set-out{color:#A8492A;font-size:12px}' +
      '.ct-set-instock{margin:2px 0 12px;padding:10px 12px;border:1px solid #A8492A;border-radius:4px;color:#A8492A;font-size:13px;font-weight:600;line-height:1.45}' +
      '.ct-set-instock[hidden],.ct-set-box .ct-notify-box[hidden]{display:none!important}' +
      '.ct-set-instock a{color:#A8492A;text-decoration:underline;cursor:pointer;font-weight:600}' +
      '.ct-set-box .ct-notify-box{margin:0}' +
      '.ct-alt-dot{width:22px;height:22px;border-radius:50%;border:1px solid #E7E6E1;background-size:cover;background-position:center;flex:0 0 auto}' +
      // a colour that doesn't have the picked size: the colour fades, a line goes through it, still tappable.
      // Only the colour fades, never the line; the line is dark with a white edge so it shows on every
      // colour, and slants like the theme's own crossed-out sizes (Nupur, 15 Oct 2026: "some have cross and some don't")
      '.f-swatch__list__link.ct-sw-out{position:relative}' +
      '.f-swatch__list__link.ct-sw-out .f-swatch__list__link__content{opacity:.4}' +
      '.f-swatch__list__link.ct-sw-out::after{content:"";position:absolute;left:50%;top:-20%;height:140%;width:1.5px;margin-left:-.75px;background:#1A1B19;box-shadow:0 0 0 1px rgba(255,255,255,.85);transform:rotate(-45deg);pointer-events:none;z-index:2}' +
      // the colour you're on: filled like the rest (the theme blanks its middle), with a short grey line under it.
      // The line sits inside the swatch's own 8px of space below it: the theme hides anything under the last row
      // (Nupur, 15 Oct 2026: "no underline!" on Leek Green, the last colour; "a grey line")
      '.f-swatch__list__link.ct-sw-here::before{background:transparent!important}' +
      '.ct-sw-here-item{position:relative}' +
      '.ct-sw-here-item::after{content:"";position:absolute;left:22%;right:22%;bottom:2px;height:2px;border-radius:2px;background:#8C8A82;pointer-events:none}' +
      '.ct-colour-tab{margin-left:6px;font-weight:400;color:#55554F;text-decoration:underline;cursor:pointer}'
    document.head.appendChild(s)
  }

  // the main product's size picker — never another product's picker placed on the page
  function opts() { return document.querySelector('.wt-product__main variant-options') || document.querySelector('variant-options') }
  function mainBtn() { return document.querySelector('.wt-product__add-to-cart_form--wrapper .js-add-to-cart') }
  function label(b) { return b && (b.querySelector(':scope > span') || b.querySelector('span')) }
  // the size the shopper picked, when it's sold out — the theme shows "Sold out" only once a size is chosen
  function soldOutPick() {
    var o = opts(), v = o && o.currentVariant
    if (!v || v.available) return null
    if (location.search.indexOf('variant=') < 0 && !(o.querySelector('input:checked'))) return null
    return { id: v.id, size: String(v.title || v.option1 || '').trim() }
  }

  // this product's sizes, as the page's size picker holds them
  function variants() {
    var o = opts(), d = null
    try { d = o && (o.variantData || JSON.parse(o.querySelector('[type="application/json"]').textContent)) } catch (e) {}
    return d && d.length ? d : []
  }
  // every size sold out (none on Continue selling) — the page then asks for a size first
  function allSoldOut() { var d = variants(); return !!(d.length && d.every(function (v) { return !v.available })) }
  function sizePicked() { var o = opts(); return location.search.indexOf('variant=') >= 0 || !!(o && o.querySelector('input:checked')) }
  // the theme's own "pick a size" nudge (pdp.js ctJumpToSizes): scroll to the sizes and flash them
  function jumpToSizes() {
    var list = document.querySelector('.wt-product__main .f-button__list') || opts()
    if (!list) return
    list.scrollIntoView({ behavior: 'smooth', block: 'center' })
    list.classList.add('ct-size-attn')
    setTimeout(function () { list.classList.remove('ct-size-attn') }, 1800)
  }

  // ── In stock in your size: the other colours of this style that have the picked size ──
  // The colour swatches link to each colour's page; their public .js says which sizes can be bought.
  var altCache = {}, altEl = null, altFor = null
  var canon = function (z) { z = String(z || '').trim().toUpperCase(); return z === 'XXL' ? '2XL' : z === 'XXXL' ? '3XL' : z }
  function swatches() {
    var seen = {}
    return Array.prototype.slice.call(document.querySelectorAll('.wt-product__main .f-swatch__list__link')).map(function (a) {
      var h = ((a.getAttribute('href') || '').match(/^\/products\/([^/?#]+)/) || [])[1]
      if (!h || seen[h] || location.pathname === '/products/' + h) return null
      seen[h] = 1
      var dot = a.querySelector('.f-swatch__list__link__content')
      return { handle: h, style: dot ? dot.getAttribute('style') || '' : '' }
    }).filter(Boolean)
  }
  function productJs(h) {
    return altCache[h] || (altCache[h] = fetch('/products/' + h + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null }).catch(function () { return null }))
  }
  function closeAlts() { if (altEl) { altEl.remove(); altEl = null } altFor = null }
  function showAlts(pick) {
    if (altFor === pick.id) return                  // already showing, or still reading the colours for this size
    closeAlts()
    altFor = pick.id
    var list = swatches().slice(0, 30)
    if (!list.length) return
    Promise.all(list.map(function (s) { return productJs(s.handle).then(function (p) { return { s: s, p: p } }) })).then(function (got) {
      if (altFor !== pick.id || !pickNow || pickNow.id !== pick.id) return
      if (altEl) altEl.remove()
      var hits = got.map(function (g) {
        var v = g.p && (g.p.variants || []).filter(function (v) { return v.available && canon(v.title || v.option1) === canon(pick.size) })[0]
        return v ? { s: g.s, v: v, colour: ((g.p.title || '').match(/\(([^)]+)\)\s*$/) || [])[1] || g.p.title } : null
      }).filter(Boolean)
      if (!hits.length) return
      var anchor = box && document.body.contains(box) ? box : (mainBtn() && mainBtn().closest('form'))
      if (!anchor) return
      altEl = altsBox(pick.size + ' is in stock in:', hits.map(function (h) { return { href: '/products/' + h.s.handle + '?variant=' + h.v.id, style: h.s.style, label: h.colour } }))
      anchor.parentNode.insertBefore(altEl, anchor.nextSibling)
    })
  }
  // ── Your size in every colour (Nupur, 15 Oct 2026: "Aritzia does it: tap a size, all colours in that
  // size highlight") ── once a size is picked, the colour swatches show which colours have it (the rest
  // fade, with a line through), and a colour that has it opens with that size already picked.
  var swFor = null
  function markSwatches() {
    var o = opts(), v = o && o.currentVariant
    var size = v && sizePicked() ? String(v.title || v.option1 || '').trim() : ''
    if (size === swFor) return
    swFor = size
    var links = Array.prototype.slice.call(document.querySelectorAll('.wt-product__main .f-swatch__list__link'))
    links.forEach(function (a) {
      if (a.dataset.ctHref == null) a.dataset.ctHref = a.getAttribute('href') || ''
      a.classList.remove('ct-sw-out')
      a.setAttribute('href', a.dataset.ctHref)
      if (a.dataset.ctLabel) { a.removeAttribute('aria-label'); a.removeAttribute('title'); delete a.dataset.ctLabel }
    })
    if (!size) return
    css()
    links.forEach(function (a) {
      var h = (a.dataset.ctHref.match(/^\/products\/([^/?#]+)/) || [])[1]
      if (!h || location.pathname === '/products/' + h) return
      productJs(h).then(function (p) {
        if (swFor !== size || !p) return                     // they picked another size meanwhile, or the colour didn't answer
        var hit = (p.variants || []).filter(function (x) { return canon(x.title || x.option1) === canon(size) })[0]
        // the colour opens on their size either way: buyable, or its Notify me and the colours that have it
        if (hit) a.setAttribute('href', '/products/' + h + '?variant=' + hit.id)
        if (!hit || !hit.available) a.classList.add('ct-sw-out')
        // said out loud too, not by colour alone (Baymard; screen readers)
        var colour = ((p.title || '').match(/\(([^)]+)\)\s*$/) || [])[1] || p.title
        var words = colour + ': ' + size + (hit && hit.available ? ' in stock' : ' sold out')
        a.setAttribute('aria-label', words); a.setAttribute('title', words); a.dataset.ctLabel = '1'
      })
    })
  }
  // The colour you're on (Nupur, 15 Oct 2026: "when I select a colour it has a border and the colour becomes
  // blank, others go cross, this is confusing; an underline below the hex?"): filled, with a line under it.
  function markCurrentColour() {
    var here = Array.prototype.slice.call(document.querySelectorAll('.wt-product__main .f-swatch__list__link')).filter(function (a) {
      return a.classList.contains('active') || (a.dataset.ctHref || a.getAttribute('href')) === location.pathname
    })
    if (!here.length) return
    css()
    here.forEach(function (a) { a.classList.add('ct-sw-here'); if (a.parentElement) a.parentElement.classList.add('ct-sw-here-item') })
  }
  // Solid / Melange tabs (Nupur, 15 Oct 2026: "when I shift from solid to melange or back, it lands on a colour
  // but no underline"): the colour you're on sits in one tab. While the other tab shows, the heading says where
  // it is, "Color: Charcoal Melange (in Melange colors)", and a tap on that goes back to it.
  function markColourTab() {
    var here = document.querySelector('.wt-product__main .f-swatch__list__link.ct-sw-here')
    var body = here && here.closest('.wt-product__option__body[data-tab]')
    var head = here && here.closest('.wt-product__option') && here.closest('.wt-product__option').querySelector('.wt-product__option__title .label')
    if (!body || !head) return
    var on = document.querySelector('.wt-product__main .tab-btn.active-color')
    var btn = document.querySelector('.wt-product__main .tab-btn[data-tab="' + body.getAttribute('data-tab') + '"]')
    var want = on && btn && on !== btn ? '(in ' + btn.textContent.trim() + ')' : ''
    var hint = head.querySelector('.ct-colour-tab')
    if ((hint ? hint.textContent : '') === want) return
    if (hint) hint.remove()
    if (!want) return
    css()
    hint = document.createElement('a')
    hint.className = 'ct-colour-tab'
    hint.href = '#'
    hint.setAttribute('role', 'button')
    hint.textContent = want
    hint.addEventListener('click', function (e) { e.preventDefault(); btn.click() })
    head.appendChild(hint)
  }
  // after the theme's own tab switch (its handler sits on the tab itself, so it has run by now)
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.tab-btn')) setTimeout(function () { try { markColourTab() } catch (x) {} }, 0)
  })
  // the bordered box of colour chips: six to start (theme's swatch order), the rest behind "+N more"
  // so a phone isn't a wall of chips
  function altsBox(heading, items) {
    var el = document.createElement('div'), SHOW = 6
    el.className = 'ct-alts'
    el.innerHTML = '<div class="ct-alts-h">' + esc(heading) + '</div><div class="ct-alts-row">' +
      items.map(function (h, i) {
        return '<a class="ct-alt" href="' + esc(h.href) + '"' + (i >= SHOW ? ' hidden' : '') + '><span class="ct-alt-dot" style="' + esc(h.style) + '"></span>' + esc(h.label) + '</a>'
      }).join('') +
      (items.length > SHOW ? '<button type="button" class="ct-alt-more">+' + (items.length - SHOW) + ' more colour' + (items.length - SHOW === 1 ? '' : 's') + '</button>' : '') + '</div>'
    var more = el.querySelector('.ct-alt-more')
    if (more) more.addEventListener('click', function () { el.querySelectorAll('.ct-alt[hidden]').forEach(function (a) { a.hidden = false }); more.remove() })
    return el
  }

  // someone who left an email last time starts on email; `editing` = sizes whose "Change" is open
  var box = null, mode = (knownContact() || {}).e ? 'e' : 'p', pickNow = null, waitingForSize = false, editing = {}
  // asked for this size, and not changing the number: the one test the button, the bar and the box all use
  function doneFor(id) { return isDone(id) && !!knownContact() && !editing[id] }

  function setSticky(on, done) {
    // the bar's Buy now: switched off on the element itself — the theme's own
    // CSS (ct-polish-2) re-draws the bar full width when it sees that
    var bn = document.querySelector('.ct-sticky-buynow')
    if (bn && on && !bn.dataset.ctHid) { bn.dataset.ctHid = '1'; bn.style.setProperty('display', 'none', 'important') }
    if (bn && !on && bn.dataset.ctHid) { bn.style.removeProperty('display'); delete bn.dataset.ctHid }
    var s = label(document.querySelector('.wt-product__sticky-buy__button'))
    if (!s) return
    if (on) { if (!s.dataset.ctText) s.dataset.ctText = s.textContent; s.textContent = done ? TXT.stickyDone : TXT.sticky }
    else if (s.dataset.ctText) { s.textContent = s.dataset.ctText; delete s.dataset.ctText }
  }

  function apply() {
    var b = mainBtn(), span = label(b)
    if (!b || !span) return
    try { markSwatches() } catch (e) {}
    try { markColourTab() } catch (e) {}   // a size change may redraw the heading
    var pick = soldOutPick()
    pickNow = pick
    // nothing picked yet on a product sold out in every size: ask for the size first
    waitingForSize = !pick && !sizePicked() && allSoldOut()
    if (waitingForSize) {
      closeAlts()
      css()
      step('shown')
      document.body.classList.add('ct-notify-on')
      b.classList.add('ct-notify-btn')
      b.removeAttribute('disabled')
      if (!b.dataset.ctAria) b.dataset.ctAria = b.getAttribute('aria-label') || 'Add to cart'
      span.textContent = TXT.pick
      b.setAttribute('aria-label', TXT.pick)
      setSticky(true, false)
      // phones hide the main button, so there the words sit where Buy now was
      if (b.offsetParent) { closeBox(); return }
      var x = ensureBox()
      if (x) { x.dataset.mode = 'pick'; x.innerHTML = '<div class="ct-nf-note">Every size is sold out. Select your size to get a WhatsApp when it’s back.</div>' }
      return
    }
    if (!pick) closeAlts()
    if (!pick) {
      if (b.classList.contains('ct-notify-btn')) {
        b.classList.remove('ct-notify-btn')
        if (b.dataset.ctAria) { b.setAttribute('aria-label', b.dataset.ctAria); delete b.dataset.ctAria }
      }
      document.body.classList.remove('ct-notify-on')
      setSticky(false)
      closeBox()
      return
    }
    css()
    step('shown')
    document.body.classList.add('ct-notify-on')
    b.classList.add('ct-notify-btn')
    b.removeAttribute('disabled')
    if (!b.dataset.ctAria) b.dataset.ctAria = b.getAttribute('aria-label') || 'Add to cart'
    var c = knownContact(), done = doneFor(pick.id)
    if (done) {
      span.textContent = '✓ We’ll ' + said(c) + ' when ' + pick.size + ' is back'
      showDoneLine(c, pick.size)
    } else {
      span.textContent = TXT.cta
      // the number box stays open on a sold-out size (kept as is while they type)
      if (!box || !document.body.contains(box) || box.dataset.mode !== 'form') openForm(false, false)  // replaces the "select your size" line too
    }
    b.setAttribute('aria-label', span.textContent)
    setSticky(true, done)
    showAlts(pick)
  }

  function ensureBox() {
    var b = mainBtn()
    if (!b) return null
    if (box && document.body.contains(box)) return box
    box = document.createElement('div')
    box.className = 'ct-notify-box'
    var anchor = b.closest('form') || b
    anchor.parentNode.insertBefore(box, anchor.nextSibling)
    return box
  }
  function closeBox() { if (box) { box.remove(); box = null } }

  function showDoneLine(c, size) {
    var x = ensureBox()
    if (!x) return
    x.dataset.mode = 'done'
    // the box turns into the confirmation, in the same place (phones hide the main button,
    // so this is where they see it) — the bottom bar confirms too
    x.innerHTML = '<div class="ct-nf-done">✓ We’ll ' + said(c) + ' when ' + esc(size) + ' is back</div>' +
      '<div class="ct-nf-note">On ' + esc(masked(c)) + ' · <a class="ct-nf-change" href="#" role="button">Change</a></div>'
    x.querySelector('.ct-nf-change').addEventListener('click', function (e) {
      e.preventDefault()
      // the size is open again until they send: the button and the bar say Notify me and send what's typed
      if (pickNow) editing[pickNow.id] = true
      apply()
      openForm(true, true)
    })
  }

  // fresh: start empty (Change / switch to email) · focus: a person asked for it, so bring it into view
  function openForm(fresh, focus) {
    var x = ensureBox()
    if (!x) return
    x.dataset.mode = 'form'
    var em = mode === 'e'
    x.innerHTML =
      '<form class="ct-nf" novalidate>' +
        '<div class="ct-nf-row">' +
          (em ? '' : '<span class="ct-nf-cc">+91</span>') +
          '<input class="ct-nf-in" ' + (em
            ? 'type="email" inputmode="email" autocomplete="email" placeholder="Your email" aria-label="Your email"'
            : 'type="tel" inputmode="numeric" autocomplete="tel-national" placeholder="WhatsApp number" aria-label="WhatsApp number" maxlength="20"') + '>' +
          '<input class="ct-nf-hp" name="ct_x9" tabindex="-1" autocomplete="off" aria-hidden="true">' +
          '<button type="submit" class="ct-nf-go button button--secondary">' + TXT.go + '</button>' +
        '</div>' +
        '<div class="ct-nf-note">We’ll message you once when it’s back. <a class="ct-nf-swap" href="#" role="button">' + (em ? 'Use WhatsApp instead' : 'Prefer email?') + '</a></div>' +
        '<div class="ct-nf-err" role="alert"></div>' +
      '</form>'
    var f = x.querySelector('form'), inp = x.querySelector('.ct-nf-in')
    if (!fresh) { var c = em ? get(KEY_CONTACT) : knownContact(); if (c && !em && c.p) inp.value = c.p; if (c && em && c.e) inp.value = c.e }
    inp.addEventListener('focus', function () { step('tap') }, { once: true })
    inp.addEventListener('input', function () { step('typed') }, { once: true })
    x.querySelector('.ct-nf-go').addEventListener('click', function () { step('tap') })
    x.querySelector('.ct-nf-swap').addEventListener('click', function (e) { e.preventDefault(); mode = em ? 'p' : 'e'; openForm(true, true) })
    f.addEventListener('submit', function (e) {
      e.preventDefault()
      var err = x.querySelector('.ct-nf-err')
      var c = em ? (email(inp.value) ? { e: email(inp.value) } : null) : (mobile(inp.value) ? { p: mobile(inp.value) } : null)
      if (!c) { err.textContent = em ? 'Check the email address.' : 'Check the number (10 digits).'; inp.focus(); return }
      send(c, x.querySelector('.ct-nf-hp').value)
    })
    if (!focus) return
    try { inp.focus({ preventScroll: true }) } catch (e) { inp.focus() }
    x.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  // saves at once on screen; the request finishes in the background
  function send(c, trap) {
    var pick = pickNow
    if (!pick) return
    put(KEY_CONTACT, c)
    markDone(pick.id)
    delete editing[pick.id]
    apply()
    var body = { v: pick.id, pg: location.pathname, hp: trap || '' }
    if (c.p) body.p = c.p; else body.e = c.e
    withExtras(body)
    fetch(ENDPOINT, { method: 'POST', body: JSON.stringify(body), keepalive: true, mode: 'cors', credentials: 'omit' })
      .then(function (r) { return r.json().catch(function () { return { ok: r.ok } }) })
      .then(function (j) { if (!j || !j.ok) fail(pick, j && j.why, c) })
      .catch(function () { fail(pick, 'later', c) })
  }
  function fail(pick, why, c) {
    unmarkDone(pick.id)
    if (why === 'phone' || why === 'email') put(KEY_CONTACT, null)
    apply()
    var here = pickNow && pickNow.id === pick.id
    if (here) {
      openForm(false, true)
      var inp = box && box.querySelector('.ct-nf-in')
      if (inp && c && (mode === 'e') === !!c.e) inp.value = c.p || c.e   // what they typed stays, to fix
    }
    var err = box && box.querySelector('.ct-nf-err')
    if (err) err.textContent = !here ? 'Couldn’t save ' + pick.size + '. Select it again and retry.'
      : why === 'phone' ? 'Check the number (10 digits).' : why === 'email' ? 'Check the email address.' : 'Couldn’t save just now. Please try again.'
  }

  // the button's own click: never add to cart while it says Notify me
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('.ct-notify-btn')
    if (!b) return
    // a buyable size on screen: never block it, whatever state we were left in (sales audit, 14 Oct 2026)
    if (!soldOutPick() && !(!sizePicked() && allSoldOut())) { b.classList.remove('ct-notify-btn'); try { apply() } catch (x) {} return }
    e.preventDefault()
    e.stopImmediatePropagation()
    var pick = pickNow
    if (!pick) { if (waitingForSize) jumpToSizes(); return }
    step('tap')
    if (doneFor(pick.id)) { if (box) box.scrollIntoView({ behavior: 'smooth', block: 'center' }); return }
    // the box is open below: send what's in it, or take them to it
    var f = box && box.querySelector('form.ct-nf'), inp = f && f.querySelector('.ct-nf-in')
    if (!f) { openForm(false, true); return }
    if (inp && (mode === 'e' ? email(inp.value) : mobile(inp.value))) { f.requestSubmit ? f.requestSubmit() : f.dispatchEvent(new Event('submit', { cancelable: true })) }
    else {
      // empty or half-typed: keep what they typed, take them to the box
      if (inp && inp.value.trim()) f.querySelector('.ct-nf-err').textContent = mode === 'e' ? 'Check the email address.' : 'Check the number (10 digits).'
      try { inp.focus({ preventScroll: true }) } catch (err) { inp.focus() }
      box.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }, true)

  // Enter in the quantity box (or any other way in) submits an add-to-cart form: never for the
  // sold-out size on screen. The page has two such forms carrying the same size, so check them all.
  document.addEventListener('submit', function (e) {
    var f = e.target
    if (!f || !f.getAttribute || (f.classList && f.classList.contains('ct-nf'))) return
    if (!/\/cart\/add/.test(f.getAttribute('action') || '')) return
    var idIn = f.querySelector('input[name="id"]')
    // only this product's own sold-out size — never another product's form on the page (cart audit, 14 Oct 2026)
    var mine = !!idIn && variants().some(function (v) { return String(v.id) === String(idIn.value) })
    var soldOut = pickNow ? (idIn && String(idIn.value) === String(pickNow.id)) : (waitingForSize && mine)
    if (!soldOut) return
    e.preventDefault()
    e.stopImmediatePropagation()
    if (waitingForSize) { jumpToSizes(); return }
    var inp = box && box.querySelector('.ct-nf-in')
    if (inp) { try { inp.focus({ preventScroll: true }) } catch (err) { inp.focus() } box.scrollIntoView({ behavior: 'smooth', block: 'center' }) }
  }, true)

  function hook(proto, name) {
    var orig = proto[name]
    if (typeof orig !== 'function' || orig.ctNotify) return
    var wrapped = function () { var r = orig.apply(this, arguments); try { apply() } catch (e) {} return r }
    wrapped.ctNotify = true
    proto[name] = wrapped
  }
  // Theme bug fix (found 14 Oct 2026): a page opened on a sold-out size's link
  // (?variant=…) is drawn without the "Low stock" label, so the theme's
  // updateInventoryIndicator crashes on the next pick of a size with 1–9 left —
  // and the crash stops the size change half-way: the button stays "Sold out"
  // and the cart would still get the sold-out size. Put the label back first,
  // and never let this one display step stop a size change.
  function safeInventory(proto) {
    var orig = proto.updateInventoryIndicator
    if (typeof orig !== 'function' || orig.ctNotify) return
    var wrapped = function () {
      try {
        document.querySelectorAll('.product__inventory').forEach(function (el) {
          if (el.querySelector('.inventory-text')) return
          // the page's own words ("Out of stock") go, the dots stay, the label comes back
          Array.prototype.slice.call(el.childNodes).forEach(function (n) { if (n.nodeName.toLowerCase() !== 'svg') n.remove() })
          var s = document.createElement('span'); s.className = 'inventory-text'; el.appendChild(s)
        })
        return orig.apply(this, arguments)
      } catch (e) {}
    }
    wrapped.ctNotify = true
    proto.updateInventoryIndicator = wrapped
  }
  // ── Set pages ──────────────────────────────────────────────────────────────
  var setEl = null, setPick = {}, setSig = ''
  // the product's own name (the heading) — the search title can differ: the V-Neck Lounge Sets are
  // "…Night Suit for Women" there (audit, 14 Oct 2026)
  function pageTitle() {
    var h = document.querySelector('.wt-product__name'), m = document.querySelector('meta[property="og:title"]')
    return (h && h.textContent.trim()) || (m && m.getAttribute('content')) || document.title || ''
  }
  function isSetPage() { var t = pageTitle(); return /\bsets?\b|co-?ord/i.test(t) && !/pack of|bundle|combo/i.test(t) }
  // each piece in YourToken's picker: its title as the picker prints it, all its sizes, and the ones it greys out
  function setPieces() {
    var pieces = []
    Array.prototype.slice.call(document.querySelectorAll('.yt-comboBundle-product-option-button')).forEach(function (b) {
      var el = b.parentElement
      while (el && el !== document.body && el.querySelectorAll('.yt-comboBundle-product-title-text').length !== 1) el = el.parentElement
      if (!el || el === document.body) return
      var p = pieces.filter(function (x) { return x.el === el })[0]
      if (!p) { p = { el: el, title: el.querySelector('.yt-comboBundle-product-title-text').textContent.trim(), all: [], out: [] }; pieces.push(p) }
      var z = b.textContent.trim()
      if (p.all.indexOf(z) < 0) p.all.push(z)
      if (b.disabled) p.out.push(z)
    })
    return pieces
  }
  // "UltraSoft Bamboo Lounge Pant (Plum)" → "Bamboo Lounge Pant"; "(2 Pockets)" stays, the colour goes
  function pieceName(t) { return t.replace(/\s*\([^)]*\)\s*$/, '').replace(/^UltraSoft\s+/i, '') }
  function setDoneId() { return 'set:' + location.pathname }

  // ── In stock in your sizes, on a set page (Nupur, 14 Oct 2026: "in sets, the same thing") ──
  // The set's other colours (its swatches, each its own set page) where every size they tapped is
  // in stock. A piece in another colour is the same name with that colour ("UltraSoft Bamboo Tee
  // (Pine Green)"), found through the store's own search; its .js says which sizes can be bought.
  var pieceHandles = {}, setAltEl = null, setAltKey = null
  function norm(t) { return String(t || '').replace(/\s+/g, ' ').trim().toLowerCase() }
  function colourOf(t) { return (String(t || '').match(/\(([^)]+)\)\s*$/) || [])[1] || null }
  function pieceHandle(title) {
    if (pieceHandles[title]) return pieceHandles[title]
    return (pieceHandles[title] = fetch('/search/suggest.json?q=' + encodeURIComponent(title) + '&resources[type]=product&resources[limit]=4', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null })
      .then(function (j) {
        var hit = ((j && j.resources && j.resources.results && j.resources.results.products) || []).filter(function (p) { return norm(p.title) === norm(title) })[0]
        return hit ? hit.handle : null
      }).catch(function () { return null }))
  }
  // the size YourToken has chosen for a piece: the tag beside its name
  function chosenSize(el) { var t = el && el.querySelector('[class*="product-variant-tag"]'); return t ? t.textContent.trim() : '' }
  // The whole combo (Nupur, 14 Oct 2026: "it should show the upsell for both combo"): the sizes
  // they tapped here, with the size picked in YourToken's own picker for any piece they didn't tap.
  // Shown once a size they tapped is sold out; changing a size in either place updates it.
  function showSetAlts() {
    var now = setPieces()
    var picks = now.some(function (p) { return setPick[p.title] && p.out.indexOf(setPick[p.title]) >= 0 }) ? now.map(function (p) {
      var z = setPick[p.title] || chosenSize(p.el)
      return z ? { title: p.title, size: z } : null
    }).filter(Boolean) : []
    var key = picks.map(function (x) { return x.title + '=' + x.size }).join('|')
    if (key === setAltKey && (!setAltEl || document.body.contains(setAltEl))) return
    setAltKey = key
    if (setAltEl) { setAltEl.remove(); setAltEl = null }
    var here = colourOf(pageTitle())
    // only pieces named in this set's colour can be looked up in another colour
    if (!picks.length || !here || picks.some(function (x) { return norm(colourOf(x.title)) !== norm(here) })) return
    var list = swatches().slice(0, 12)
    if (!list.length) return
    Promise.all(list.map(function (s) {
      return productJs(s.handle).then(function (set) {
        var c = set && set.available && colourOf(set.title)
        if (!c) return null
        return Promise.all(picks.map(function (x) {
          return pieceHandle(x.title.replace(/\([^)]+\)\s*$/, '(' + c + ')'))
            .then(function (h) { return h ? productJs(h) : null })
            .then(function (p) { return !!(p && (p.variants || []).some(function (v) { return v.available && canon(v.title || v.option1) === canon(x.size) })) })
        })).then(function (ok) { return ok.every(Boolean) ? { s: s, colour: c } : null })
      })
    })).then(function (got) {
      if (key !== setAltKey || !setEl || !document.body.contains(setEl)) return       // they tapped another size meanwhile
      var hits = got.filter(Boolean)
      if (setAltEl) { setAltEl.remove(); setAltEl = null }
      if (!hits.length) return
      var what = picks.map(function (x) { return pieceName(x.title) + ' ' + x.size }).join(' · ')
      setAltEl = altsBox(what + (picks.length > 1 ? ' are' : ' is') + ' in stock in:', hits.map(function (h) { return { href: '/products/' + h.s.handle, style: h.s.style, label: h.colour } }))
      setEl.parentNode.insertBefore(setAltEl, setEl.nextSibling)
    })
  }
  function startSet() {
    if (!isSetPage()) return
    // a size picked in YourToken's own picker changes the combo: the colours follow once its tag updates
    // (heard on the way down — YourToken's own handler stops the click there)
    document.addEventListener('click', function (e) {
      if (!setEl || !e.target || !e.target.closest || !e.target.closest('.yt-comboBundle-product-option-button')) return
      setTimeout(showSetAlts, 300); setTimeout(showSetAlts, 1200)
    }, true)
    // watch the picker for its first 20 s: it may grey sizes out after drawing them, or draw itself
    // again — the box follows (and comes back if a redraw took it away); the same picker never redraws ours
    var tries = 0
    var t = setInterval(function () {
      var pieces = setPieces()
      var sig = pieces.map(function (p) { return p.title + ':' + p.out.join(',') }).join('|')
      if (pieces.length && (sig !== setSig || (setEl && !document.body.contains(setEl)))) { setSig = sig; renderSet(pieces) }
      if (++tries > 40) clearInterval(t)
    }, 500)
  }
  function renderSet(pieces) {
    var outPieces = pieces.filter(function (p) { return p.out.length })
    if (!outPieces.length) {                         // every size of every piece can be bought: no box
      if (setEl) { setEl.remove(); setEl = null }
      if (setAltEl) { setAltEl.remove(); setAltEl = null }
      return
    }
    css()
    step('shown')
    if (!setEl || !document.body.contains(setEl)) {
      // under the set's own Add to Cart (the visible one), so buying in stock sizes is untouched
      var list = document.querySelector('.yt-comboBundle-products-list-horizontal') || outPieces[0].el
      var ctas = Array.prototype.slice.call(document.querySelectorAll('.yt-comboBundle-bundle-cta-button'))
      var cta = ctas.filter(function (c) { return c.offsetParent })[0] || ctas[0]
      var anchor = list
      if (cta) { anchor = cta; while (anchor.parentElement && !anchor.parentElement.contains(list)) anchor = anchor.parentElement }
      setEl = document.createElement('div')
      setEl.className = 'ct-set-box'
      anchor.parentNode.insertBefore(setEl, anchor.nextSibling)
    }
    var done = doneList().filter(function (x) { return x.id === setDoneId() })[0], c = knownContact()
    if (done && c) {
      setEl.innerHTML = '<div class="ct-nf-done">✓ We’ll ' + said(c) + ' when your set is back</div>' +
        '<div class="ct-nf-note">' + (done.what ? String(done.what).replace(/</g, '&lt;') + ' · ' : '') + 'On ' + masked(c) + ' · <a class="ct-nf-change" href="#" role="button">Change</a></div>'
      setEl.querySelector('.ct-nf-change').addEventListener('click', function (e) { e.preventDefault(); unmarkDone(setDoneId()); renderSet(pieces) })
      showSetAlts()
      return
    }
    var em = mode === 'e'
    // every piece in every size (Nupur, 14 Oct 2026: "show all sizes — someone may want a sold-out one
    // with another in-stock item"); the sold-out ones are named beside the piece and dashed
    setEl.innerHTML = '<div class="ct-alts-h">Size sold out? Get a WhatsApp when it’s back</div>' +
      pieces.map(function (p, i) {
        var outLine = !p.out.length ? '' : p.out.length === p.all.length ? 'sold out in every size' : 'sold out: ' + p.out.join(' ')
        return '<div class="ct-set-piece"><div class="ct-set-name">' + esc(pieceName(p.title)) + (outLine ? ' <span class="ct-set-out">· ' + esc(outLine) + '</span>' : '') + '</div><div class="ct-set-sizes">' +
          p.all.map(function (z) {
            return '<button type="button" class="ct-sz' + (p.out.indexOf(z) >= 0 ? ' ct-sz-out' : '') + (setPick[p.title] === z ? ' ct-sz-on' : '') + '" data-i="' + i + '" data-z="' + esc(z) + '">' + esc(z) + '</button>'
          }).join('') +
          '</div></div>'
      }).join('') +
      // every size they picked can be bought: point them at the set's own Add to Cart (we never touch YourToken's cart)
      '<div class="ct-set-instock" hidden>Your sizes are in stock. Select them above and Add to Cart. <a class="ct-set-up" href="#" role="button">Take me there</a></div>' +
      '<form class="ct-nf" novalidate>' +
        '<div class="ct-nf-row">' + (em ? '' : '<span class="ct-nf-cc">+91</span>') +
          '<input class="ct-nf-in" ' + (em
            ? 'type="email" inputmode="email" autocomplete="email" placeholder="Your email" aria-label="Your email"'
            : 'type="tel" inputmode="numeric" autocomplete="tel-national" placeholder="WhatsApp number" aria-label="WhatsApp number" maxlength="20"') + '>' +
          '<input class="ct-nf-hp" name="ct_x9" tabindex="-1" autocomplete="off" aria-hidden="true">' +
          '<button type="submit" class="ct-nf-go button button--secondary">' + TXT.go + '</button>' +
        '</div>' +
        '<div class="ct-nf-note">We’ll message you once when your set is back. <a class="ct-nf-swap" href="#" role="button">' + (em ? 'Use WhatsApp instead' : 'Prefer email?') + '</a></div>' +
        '<div class="ct-nf-err" role="alert"></div>' +
      '</form>'
    // the number box sits in our box the way it does on a product page
    var wrap = document.createElement('div'); wrap.className = 'ct-notify-box'
    var f = setEl.querySelector('form'); f.parentNode.insertBefore(wrap, f); wrap.appendChild(f)
    var inp = setEl.querySelector('.ct-nf-in'), err = setEl.querySelector('.ct-nf-err'), inStock = setEl.querySelector('.ct-set-instock')
    if (em) { var ce = get(KEY_CONTACT); if (ce && ce.e) inp.value = ce.e } else { var cp = knownContact(); if (cp && cp.p) inp.value = cp.p }
    // a size picked for every piece, and none of them sold out: the set can be bought now — the red
    // note only, no Notify me (Nupur, 14 Oct 2026: "if it's already possible to add to cart, don't give the option")
    function allInStock() { return pieces.every(function (p) { return setPick[p.title] && p.out.indexOf(setPick[p.title]) < 0 }) }
    function showInStock() { var all = allInStock(); inStock.hidden = !all; wrap.hidden = all }
    Array.prototype.slice.call(setEl.querySelectorAll('.ct-sz')).forEach(function (b) {
      b.addEventListener('click', function () {
        step('tap')
        var p = pieces[Number(b.getAttribute('data-i'))], z = b.getAttribute('data-z')
        if (setPick[p.title] === z) delete setPick[p.title]; else setPick[p.title] = z    // one size per piece; tap again to clear
        Array.prototype.slice.call(setEl.querySelectorAll('.ct-sz[data-i="' + b.getAttribute('data-i') + '"]')).forEach(function (x) { x.classList.toggle('ct-sz-on', setPick[p.title] === x.getAttribute('data-z')) })
        err.textContent = ''
        showInStock()
        showSetAlts()
      })
    })
    setEl.querySelector('.ct-set-up').addEventListener('click', function (e) {
      e.preventDefault()
      var up = document.querySelector('.yt-comboBundle-products-list-horizontal') || pieces[0].el
      if (up) up.scrollIntoView({ behavior: 'smooth', block: 'center' })
    })
    showInStock()
    showSetAlts()
    inp.addEventListener('focus', function () { step('tap') }, { once: true })
    inp.addEventListener('input', function () { step('typed') }, { once: true })
    setEl.querySelector('.ct-nf-swap').addEventListener('click', function (e) { e.preventDefault(); mode = em ? 'p' : 'e'; renderSet(pieces) })
    f.addEventListener('submit', function (e) {
      e.preventDefault()
      // the whole combo they picked — sold-out and in-stock pieces together, told when all of it can be bought
      var items = pieces.filter(function (p) { return setPick[p.title] }).map(function (p) { return { t: p.title, z: setPick[p.title] } })
      if (!items.length) { err.textContent = 'Tap the size you need above.'; return }
      if (!pieces.some(function (p) { return setPick[p.title] && p.out.indexOf(setPick[p.title]) >= 0 })) {
        // nothing they picked is sold out: the red note says so (a whole set), or they're still choosing
        if (!inStock.hidden) inStock.scrollIntoView({ behavior: 'smooth', block: 'center' })
        else err.textContent = 'Pick a size for each piece above.'
        return
      }
      var ct = em ? (email(inp.value) ? { e: email(inp.value) } : null) : (mobile(inp.value) ? { p: mobile(inp.value) } : null)
      if (!ct) { err.textContent = em ? 'Check the email address.' : 'Check the number (10 digits).'; inp.focus(); return }
      var what = items.map(function (x) { return pieceName(x.t) + ' ' + x.z }).join(' · ')
      put(KEY_CONTACT, ct)
      var d = doneList().filter(function (x) { return x.id !== setDoneId() }); d.unshift({ id: setDoneId(), at: Date.now(), what: what }); put(KEY_DONE, d.slice(0, 50))
      renderSet(pieces)
      var body = { set: items, pg: location.pathname, hp: setEl.querySelector('.ct-nf-hp') ? setEl.querySelector('.ct-nf-hp').value : '' }
      if (ct.p) body.p = ct.p; else body.e = ct.e
      withExtras(body)
      fetch(ENDPOINT, { method: 'POST', body: JSON.stringify(body), keepalive: true, mode: 'cors', credentials: 'omit' })
        .then(function (r) { return r.json().catch(function () { return { ok: r.ok } }) })
        .then(function (j) { if (!j || !j.ok) setFail(pieces, j && j.why) })
        .catch(function () { setFail(pieces, 'later') })
    })
  }
  function setFail(pieces, why) {
    unmarkDone(setDoneId())
    if (why === 'phone' || why === 'email') put(KEY_CONTACT, null)
    renderSet(pieces)
    var err = setEl && setEl.querySelector('.ct-nf-err')
    if (err) err.textContent = why === 'phone' ? 'Check the number (10 digits).' : why === 'email' ? 'Check the email address.' : 'Couldn’t save just now. Please try again.'
  }

  function start() {
    try { landing() } catch (e) {}           // note how this visit arrived while this page is its first
    try { markCurrentColour(); markColourTab() } catch (e) {}
    if (!mainBtn()) { startSet(); return }
    document.addEventListener('variantChangeEnd', apply)
    customElements.whenDefined('variant-options').then(function () {
      var C = customElements.get('variant-options')
      if (C && C.prototype) { hook(C.prototype, 'toggleAddButton'); hook(C.prototype, 'updateATCText'); safeInventory(C.prototype) }
      var o = opts()
      Promise.resolve(o && o.whenLoaded).then(function () { setTimeout(apply, 0) })
    })
    apply()
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start)
  else start()
})()
